import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "app" }

import { computed, onMounted, ref, watch } from 'vue';
import { setupAppParams } from '@/store/modules/AppStore';
import LeafVideo from '@/components/blocks/LeafVideo.vue';
import TransitionVideo from '@/components/blocks/TransitionVideo.vue';
import Router from '@/core/Router';
import { videoStore } from './store/modules/Video';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  props: {
  'lang': {
    type: String,
    default: 'en',
    required: true
  }
},
  setup(__props) {

const props = __props;



const fontLoaded = ref<boolean>(false)
const onFontLoaded = () => fontLoaded.value = true

onMounted(() => {
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.finally(onFontLoaded)
  } else {
    onFontLoaded()
  }

  setupAppParams(props);
})

const { locale } = useI18n()
const isPlaying = computed(() => videoStore.play)
const currentLang = computed(() => locale.value)

// @TODO: update this
// watch(() => Router.beforeEach, (router) => {
//   console.log(router)
// })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (fontLoaded.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["ready", [currentLang.value]])
        }, [
          _createVNode(_Transition, { name: "fade" }, {
            default: _withCtx(() => [
              _createVNode(TransitionVideo)
            ]),
            _: 1
          }),
          _createVNode(LeafVideo),
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component, route }) => [
              _createVNode(_Transition, {
                name: "fade",
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                    key: route.meta?.unique ? route.fullPath : null,
                    "data-slug": route.meta?.unique ? route.fullPath : '',
                    class: "default"
                  }, null, 8, ["data-slug"]))
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})